




































































import { ApplipcationStoreType, Package } from "@/enums/enums";
import { CheckIsDevelop } from "@/helper/shareHelper";
import { CheckMerchantAFPPackage, MerchantId, CheckMerchantPackage } from "@/helper/userHelper";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import ModalLinePEAKConnect from "./ModalLinePEAKConnect.vue";

const StoreLogIn = namespace("LogIn");

@Component({ components: { ModalLinePEAKConnect } })
export default class ApplicationStore extends Vue {
  private isShowApplicationStore = false;
  private PeakPeakengineURL = process.env.VUE_APP_PeakEngine;
  private PeakAccountURL = process.env.VUE_APP_PeakAccount;
  private showModalLinePEAKConnect = false;
  private blobUrl = process.env.VUE_APP_PeakBlobStorage?.toString() ?? "";
  private isDevelop = CheckIsDevelop();
  private showDueDatePeakBoard = false;
  private isMerchantPackageAFP = CheckMerchantAFPPackage();
  private isFreeTrialPackage = CheckMerchantPackage([Package.Trial]);

  get isCanUsePeakBoard() {
    return this.$can("access", "PeakBoard") && !this.isMerchantPackageAFP;
  }

  get isCanUsePeakAsset() {
    return this.$can("access", "PeakAsset");
  }

  get isCanUsePeakPayroll() {
    return this.$can("access", "PeakPayroll") && !this.isMerchantPackageAFP;
  }

  get isCanUseOldPeak() {
    return !this.isMerchantPackageAFP;
  }
  get isCanUsePeakConnect() {
    return !this.isMerchantPackageAFP;
  }

  @StoreLogIn.Action
  private DoRedirectByApplicationStore!: (applipcationStoreType: ApplipcationStoreType) => void;

  public Hide() {
    this.isShowApplicationStore = false;
  }
  public RedirectToPeak() {
    this.Hide();
    this.DoRedirectByApplicationStore(ApplipcationStoreType.Peak);
  }
  public RedirectToNewPeak() {
    this.Hide();
    this.DoRedirectByApplicationStore(ApplipcationStoreType.NewPeak);
  }
  public RedirectToPeakPayroll() {
    this.Hide();
    this.DoRedirectByApplicationStore(ApplipcationStoreType.Payroll);
  }
  public RedirectToPeakBoard() {
    this.Hide();
    this.DoRedirectByApplicationStore(ApplipcationStoreType.Board);
  }
  public DoShowModalLinePEAKConnect() {
    this.Hide();
    this.showModalLinePEAKConnect = true;
  }
  public RedirectToPeakAsset() {
    this.Hide();
    this.DoRedirectByApplicationStore(ApplipcationStoreType.Asset);
  }
  public RedirectToUpgrade() {
    window.open(`${process.env.VUE_APP_PeakAccount}setting/billing?emi=${MerchantId().PeakEncryption()}`);
  }
  public RedirectToPeakTax() {
    this.$router.push({
      name: "home",
      query: { emi: MerchantId().PeakEncryption() },
    });
    this.Hide();
  }
}
